import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { Chart } from 'chart.js';
import { Constant } from '../../../blog/constant';
import { NumberUtil } from '../../../../../common/utils/number.util';
import { DateUtil } from '../../../../../common/utils/date.util';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ngx-line-chart',
  templateUrl: './ngx-line-chart.component.html',
  styleUrls: ['./ngx-line-chart.component.scss'],
})
export class NgxLineChartVerticalComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() height: number = 350;
  @Input() noLabels: boolean = false;
  @Input() noBorderGrid: boolean = false;
  isReload: boolean = false;
  isDevice: boolean = false;
  id: number = Date.now();
  public chart: any;
  width: any;
  dividendDates: any;
  iconCharts: any[] = [];
  @Input() chartData: any = {
    labels: ['NAV'],
    datasets: [
      {
        label: 'NAV',
        data: [13],
        borderColor: '',
        backgroundColor: '',
        borderWidth: 2,
        pointStyle: 'cross',
        pointBorderWidth: 0,
        pointBackgroundColor: '',
      },
    ],
  };
  chartColorRed: any = {
    borderColor: 'rgb(7,46,105)',
    backgroundColor: 'rgba(7,46,105, 0.2)',
    pointBackgroundColor: 'rgb(7,46,105)',

    borderWidth: 1,
    fill: false,
    cubicInterpolationMode: 'monotone',
    tension: 0.4,
  };
  chartColorBlue: any = {
    borderColor: 'rgb(3,104,255)',
    backgroundColor: 'rgba(3,104,255, 0.2)',
    pointBackgroundColor: 'rgb(3,104,255)',
    borderWidth: 0,
    pointBorderWidth: 0,
    pointHitRadius: 0,
    fill: false,
    cubicInterpolationMode: 'monotone',
    tension: 0.4,
  };
  constructor(private translate: TranslateService) {}
  ngOnInit() {
    if (typeof window !== 'undefined') {
      this.width = window.innerWidth;
      this.isDevice = Constant.checkAndroid() || Constant.checkIOS();
    }
  }
  ngOnChanges(simpleChanges: SimpleChanges) {
    const changes: any = simpleChanges;
    if (changes.chartData.currentValue) {
      setTimeout(() => {
        if (typeof window !== 'undefined') {
          this.createChart();
        }
      }, 1000);
    }
  }
  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
  }
  createChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    this.dividendDates = this.chartData.dividendDates || [];
    this.chartData.datasets.forEach((item: any) => {
      if (item.isColorBlue) {
        item.borderColor = this.chartColorBlue.borderColor;
        item.backgroundColor = this.chartColorBlue.backgroundColor;
        item.pointBackgroundColor = this.chartColorBlue.pointBackgroundColor;

        if (item.isFill) {
          item.fill = {
            target: 'origin',
            above: this.chartColorBlue.backgroundColor, // Area will be red above the origin
            // below: 'yellow'    // And blue below the origin
          };
        }
      }
      if (item.isColorRed) {
        item.borderColor = this.chartColorRed.borderColor;
        item.backgroundColor = this.chartColorRed.backgroundColor;
        item.pointBackgroundColor = this.chartColorRed.pointBackgroundColor;
        if (item.isFill) {
          item.fill = {
            target: 'origin',
            above: this.chartColorRed.backgroundColor, // Area will be red above the origin
            // below: 'yellow'    // And blue below the origin
          };
        }
      }
      // item.pointStyle = 'line';
      item.pointBorderWidth = 0;
      // item.fill = false;
      // item.cubicInterpolationMode = 'monotone';
      // item.tension =  0.4;
    });

    const pointImage = new Image();
    pointImage.src =
      'https://files.fmarket.vn/pro/user/1214/2959c4df-8cb0-41d3-9e82-3a1f53d38117.png';
    pointImage.width = 25;
    pointImage.height = 25;
    this.iconCharts = [];
    this.chartData.labels.forEach((label: string) => {
      const findIndex = this.dividendDates.findIndex((item: any) => {
        return DateUtil.parseDate(item.dividendDate, 'yyyy-MM-dd') === label;
      });
      if (findIndex > -1) {
        this.iconCharts.push(pointImage);
      } else {
        this.iconCharts.push('line');
      }
    });

    this.chartData.labels = this.noLabels
      ? this.chartData.labels.map((item: any) => {
          return '';
        })
      : this.chartData.labels;

    this.chart = new Chart('lineChart' + this.id, {
      type: 'line',
      data: this.chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: this.isDevice ? 0.85 : 2.5,
        scales: {
          y: {
            grace: '5%',
            beginAtZero: false,
            grid: {
              color: this.noBorderGrid ? 'white' : 'rgba(0, 0, 0, 0.1)',
            },
          },
          x: {
            grid: {
              color: this.noBorderGrid ? 'white' : 'rgba(0, 0, 0, 0.1)',
            },
          },
        },
        elements: {
          point: {
            pointStyle: this.iconCharts,
          },
        },
        plugins: {
          // title: {
          //   display: true,
          //   text: '    ',
          // },
          tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            bodyFont: {
              size: 14,
            },
            titleFont: {
              size: 16,
              weight: 'bold',
            },
            callbacks: {
              labelColor: (context) => {
                let color: string =
                  context.dataset.pointBackgroundColor + '' || '';
                const findIndex = this.dividendDates.findIndex((item: any) => {
                  return (
                    DateUtil.parseDate(item.dividendDate, 'yyyy-MM-dd') ===
                    context.label
                  );
                });
                if (findIndex > -1) {
                  color = 'green';
                }
                return {
                  borderColor: color,
                  backgroundColor: color,
                  borderWidth: 0,
                  borderDash: [0, 0],
                  borderRadius: 0,
                };
              },
              label: (context) => {
                let label = context.dataset.label || '';
                const findIndex = this.dividendDates.findIndex((item: any) => {
                  return (
                    DateUtil.parseDate(item.dividendDate, 'yyyy-MM-dd') ===
                    context.label
                  );
                });
                if (findIndex > -1) {
                  const dividendDate = this.dividendDates[findIndex];
                  // label =`Chi trả lợi tức bằng tiền : ${dividendDate.dividendPerUnit}đ/CCQ, Ngày GD không hưởng quyền: ${DateUtil.parseDate(dividendDate.exDividendDate, 'yyyy-MM-dd')}`;
                  const line1 = this.translate.instant(
                    'Chi trả lợi tức bằng tiền',
                    {
                      dividend: dividendDate.dividendPerUnit,
                    },
                  );
                  const line2 = this.translate.instant(
                    'Ngày GD không hưởng quyền',
                    {
                      date: DateUtil.parseDate(
                        dividendDate.exDividendDate,
                        'yyyy-MM-dd',
                      ),
                    },
                  );
                  return [line1, line2];
                } else {
                  label = label ? (label += ': ') : '';
                  label += NumberUtil.numberToMoney(context.parsed.y || 0);
                  label +=
                    ' ' +
                    this.translate.instant('Ngày') +
                    ': ' +
                    this.chartData.labels[context.dataIndex];
                }
                return label;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            display: false,
          },
        },
      },
    });
  }
  improveXTrick(xAxisTicks: any, divide: number = 2) {
    if (xAxisTicks.length / divide >= (this.isDevice ? 4 : 8)) {
      xAxisTicks = xAxisTicks.filter(
        (item: any, index: any) => index % divide === 0,
      );
      xAxisTicks = this.improveXTrick(xAxisTicks);
    }
    return xAxisTicks;
  }
}
